import axios from "axios";
import React, {useEffect, useState} from "react";
import { useLocation } from "react-router-dom";

export default function Agenda() {
    const location = useLocation();
    const { agendaInfo } = location.state || { agendaInfo: undefined };

    const dadosStorage = sessionStorage.getItem('agenda');
    const agenda = JSON.parse(dadosStorage);
    const [origem, setOrigem] = useState('E');

    const uuid = location.pathname.split('/')[2];

    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const [errorMessage, setErrorMessage] = useState('');
    
    const [file, setFile] = useState(null);
    const [PdfFile, setPdfFile] = useState({
            NomePdf: '',
            Arquivo: ''
        });
    const [uploadStatus, setUploadStatus] = useState('');

    const now = new Date();
    const customFormatDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens
    
    const customFormatSmallDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit'
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens
    
    const [campos, setCampos] = useState({
        IdAgenda: 0,
        ageDescricao: '',
        ageData: '',
        ageHoraInicio: '',
        ageHoraFim: '',
        ageObservacoes: '',
        ageStatus: 1,
        ageAnexo: '',
        ageCriadoPor: sessionStorage.nomeUsuario,
        ageCriadoEm: customFormatDate,
        ageAlteradoPor: sessionStorage.nomeUsuario,
        ageAlteradoEm: customFormatDate,
        ageCodigoGUID: ''
    });

    useEffect(() => {
        if (agendaInfo === undefined && agenda !== null) {
            setOrigem('N');
            campos.IdAgenda = agenda.IdAgenda;
            campos.ageDescricao = agenda.ageDescricao;
            campos.ageData = agenda.ageData;
            campos.ageHoraInicio = agenda.ageHoraInicio;
            campos.ageHoraFim = agenda.ageHoraFim;
            campos.ageObservacoes = agenda.ageObservacoes;
            campos.ageStatus = agenda.ageStatus;
            campos.ageAnexo = agenda.ageAnexo;
            campos.ageCriadoPor = sessionStorage.nomeUsuario;
            campos.ageCriadoEm = customFormatDate;
            campos.ageAlteradoPor = sessionStorage.nomeUsuario;
            campos.ageAlteradoEm = customFormatDate;
            campos.ageCodigoGUID = agenda.ageCodigoGUID;

            agendaInfo = campos;
        } 
        else if (agendaInfo !== undefined) {
            setOrigem('E');

            campos.IdAgenda = agendaInfo.IdAgenda;
            campos.ageDescricao = agendaInfo.ageDescricao;
            campos.ageData = agendaInfo.ageData;
            campos.ageHoraInicio = agendaInfo.ageHoraInicio;
            campos.ageHoraFim = agendaInfo.ageHoraFim;
            campos.ageObservacoes = agendaInfo.ageObservacoes;
            campos.ageStatus = agendaInfo.ageStatus;
            campos.ageAnexo = agendaInfo.ageAnexo;
            campos.ageCriadoPor = agendaInfo.ageCriadoPor;
            campos.ageCriadoEm = agendaInfo.ageCriadoEm;
            campos.ageAlteradoPor = sessionStorage.nomeUsuario;
            campos.ageAlteradoEm = customFormatDate;
            campos.ageCodigoGUID = agendaInfo.ageCodigoGUID;
        }
        else {
            setOrigem('N');
            agendaInfo = campos;
        }
    },'');

    if (agendaInfo !== undefined) {
        preencherCampos();
    }

    function preencherCampos() {
        campos.IdAgenda = agendaInfo.IdAgenda;
        campos.ageDescricao = agendaInfo.ageDescricao;
        campos.ageData = agendaInfo.ageData;
        campos.ageHoraInicio = agendaInfo.ageHoraInicio;
        campos.ageHoraFim = agendaInfo.ageHoraFim;
        campos.ageObservacoes = agendaInfo.ageObservacoes;
        campos.ageStatus = agendaInfo.ageStatus;
        campos.ageAnexo = agendaInfo.ageAnexo;
        campos.ageCriadoPor = agendaInfo.ageCriadoPor;
        campos.ageCriadoEm = agendaInfo.ageCriadoEm;
        campos.ageAlteradoPor = sessionStorage.nomeUsuario;
        campos.ageAlteradoEm = customFormatDate;
        campos.ageCodigoGUID = agendaInfo.ageCodigoGUID;
    }

    function handleInputChange(e) {
        campos[e.target.name] = e.target.value;
        if (agendaInfo) { 
            agendaInfo[e.target.name] = e.target.value;
        }
        //console.log(campos);
        //console.log(agendaInfo);
    }

    var bloqueio = false;
    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    function handleFecharModal(){
        if(campos.IdAgenda > 0){
            console.log('aqui-1');
            // setOpenModal(false);
            window.history.back();
        }
        else {   
            //window.location.href = '/Associado';
            console.log('aqui-2'); 
            window.history.back();
        }
    }

    function handleFormSubmit(event) {
        event.preventDefault();
        console.log('Enviando formulário de agenda:', campos);
        if (!campos.ageDescricao || campos.ageDescricao.trim() === '' 
        || !campos.ageData 
        || campos.ageData.trim() === '') {
            setErrorMessage('Preencha todos os campos obrigatórios.');
            bloqueio = true;
            return;
        } else {
            setErrorMessage('');
            bloqueio = false;
        }

        if (bloqueio === false) {
            bloqueio = true;
            if(file) {
                const formData = new FormData();
                formData.append('pdfFile', file);
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function (fileLoadedEvent) {
                var srcData = fileLoadedEvent.target.result;
                PdfFile['arquivo'] = srcData.split(',')[1];
                PdfFile['NomePDF'] = uuid + '_' + file.name;
                setPdfFile(PdfFile);
                }

                axios
                .post(process.env.REACT_APP_API_URL + 
                    '/routes.php?metodo=uploadFotoAgenda', formData
                , { headers: {
                    "X-Access-Token" : tokenAPI,
                    "Content-Type": "multipart/form-data; charset=UTF-8"
                } })
                .then(response => {
                    campos.ageAnexo = response.data['filePath'];
                    if (agendaInfo){
                        agendaInfo.ageAnexo = response.data['filePath'];
                    }
                    setUploadStatus(`Sucesso: ${response.data.message}`);
                    bloqueio = false;
                    salvarAgenda();
                })
                .catch(error => {
                    console.error('Houve um erro ao enviar o formulário:', error);
                    setUploadStatus(`Erro ao enviar: ${error.response ? error.response.data.message : error.message}`);
                    bloqueio = false;
                    return;
                });
                } else {
                    bloqueio = false;
                    salvarAgenda();
                }
            }
    }

    function salvarAgenda() {
        if (bloqueio === false) {
            if (campos.IdAgenda > 0) {
                //console.log('Atualizando agenda existente com ID:', campos.IdAgenda);
                //console.log(campos);
                axios.post(process.env.REACT_APP_API_URL +
                    '/routes.php?metodo=atualizarAgenda', campos, {
                        headers: {
                            "X-Access-Token": tokenAPI,
                            "Content-Type": "application/json; charset=UTF-8"
                        }
                    }
                )
                .then(response => {
                    bloqueio = false;
                    alert('Agenda atualizada com sucesso!');
                    window.location.href = '/#/Agendas';
                })
                .catch(error => {
                    console.error('Erro ao atualizar a agenda:', error);
                    bloqueio = false;
                    alert('Erro ao atualizar a agenda. Por favor, tente novamente.');
                });
            } else {
                //console.log('Criando nova agenda');
                //console.log(campos);
                axios.post(process.env.REACT_APP_API_URL +
                    '/routes.php?metodo=criarAgenda', campos, {
                        headers: {
                            "X-Access-Token": tokenAPI,
                            "Content-Type": "application/json; charset=UTF-8"
                        }
                    }
                )
                .then(response => {
                    bloqueio = false;
                    alert('Agenda criada com sucesso!');
                    window.location.href = '/#/Agendas';
                })
                .catch(error => {
                    console.error('Erro ao criar a agenda:', error);
                    bloqueio = false;
                    alert('Erro ao criar a agenda. Por favor, tente novamente.');
                });
            }
        }
    }

    return (
        <>
            <main>
                <div>
                    {/* fechar */}
                    <div className="d-flex w100 mt1 flex-column text-align-left">
                        <div className='text-align-left w80 fs16'>
                            <button 
                                className="buttonModalPadraoLaranja fs11" 
                                onClick={handleFecharModal}>Fechar
                            </button>
                        </div>
                    </div>
                    {/* form cadastro de agenda */}
                    <form onSubmit={handleFormSubmit} className="form-agenda d-flex flex-column w90 mt1">
                        <div className="headerMain">
                            <label className="labelTitulo">Agenda</label>
                        </div>
                        <div className="d-flex w100 flex-column tdAlignLeft pb4">

                            {/* Descricao com base no Lancamento.js */}
                            <div className="d-flex flex-row divForm">
                                <div className="w100">
                                    <div className='text-align-left divForm fs16'>
                                        <label>DESCRIÇÃO</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs12'>
                                        <input
                                        defaultValue={campos.ageDescricao}
                                            onChange={handleInputChange}
                                        className="pt1 pb1 p1 fs12 w100 text-align-left" 
                                        required
                                        name="ageDescricao"
                                        id="ageDescricao"
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Data */}
                            <div className="d-flex flex-row divForm">

                                {/* Data lancamento */}
                                <div className="w50">
                                    <div className='text-align-left divForm fs12'>
                                        <label>DATA</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs11'>
                                        <input
                                        type="date"
                                        format="DD/MM/YYYY"
                                        defaultValue={campos.ageData}
                                        onChange={handleInputChange}
                                        className="p1 fs12 w100 text-align-center" 
                                        required
                                        name="ageData"
                                        id="ageData"
                                        />
                                    </div>
                                </div>

                                {/* Hora inicio */}
                                <div className="w50">
                                    <div className='text-align-left divForm fs12'>
                                        <label>INICIO</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs1'>
                                        <input
                                        defaultValue={campos.ageHoraInicio}
                                        onChange={handleInputChange}
                                        className="pt1 pb1 p1 fs12 w100 text-align-right" 
                                        required
                                        name="ageHoraInicio"
                                        id="ageHoraInicio"
                                        />
                                    </div>
                                </div>

                                {/* Hora fim */}
                                <div className="w50">
                                    <div className='text-align-left divForm fs12'>
                                        <label>FIM</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs1'>
                                        <input
                                        defaultValue={campos.ageHoraFim}
                                        onChange={handleInputChange}
                                        className="pt1 pb1 p1 fs12 w100 text-align-right" 
                                        required
                                        name="ageHoraFim"
                                        id="ageHoraFim"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex flex-column divForm">

                                {/* Observações */}
                                <div className="d-flex flex-row divForm w100">
                                    <div className="w100">
                                        <div className='text-align-left divForm fs16'>
                                            <label>OBSERVAÇÕES</label>
                                        </div>
                                        <div className='text-align-left divForm w100 fs1'>
                                            <textarea
                                            defaultValue={campos.ageObservacoes}
                                            onChange={handleInputChange}
                                            className="p1 fs11 w100 text-align-left" 
                                            required
                                            name="ageObservacoes"
                                            id="ageObservacoes"
                                            />
                                        </div>
                                    </div>
                                </div>
                                
                                { /* upload documento */}
                                <div className="d-flex flex-column divForm w100">
                                    <div className='text-align-left w100 divForm fs16'>
                                        <label>ANEXO</label>
                                    </div>
                                    {parseInt(sessionStorage.pesAdmin) === 1 ? (
                                    <div className='text-align-center divForm w100 fs12'>
                                        <input
                                        type="file"
                                        name="ageAnexo"
                                        className="p1 bgGray fs12 w100"
                                        id="ageAnexo"
                                        accept=".jpg,.jpeg,.png,.pdf"
                                        onChange={handleFileChange}/>
                                        <p>{uploadStatus}</p>
                                    </div> ) : ('') } 
                                    <div className='text-align-left divForm w100 fs10'>
                                        <label>{campos.ageAnexo.replace('uploads/agenda/','')}</label>
                                    </div>
                                </div>
                                
                                {/* ALERTAS AVISOS */}
                                {errorMessage !== null && errorMessage !== '' ? (
                                    <div className='text-align-left divForm fs10'>
                                        <span className="AlertPassword">
                                            {errorMessage}
                                        </span>
                                    </div>
                                ) : (
                                    <div></div>
                                )}
                                <div className='text-align-left mt2 mb4 divForm fs14'>
                                    {parseInt(sessionStorage.pesAdmin) === 1 ? (
                                    <button 
                                        className='buttonModalPadrao pt1 pb2 w100 fs14'
                                        type="submit">
                                            SALVAR AGENDA
                                    </button> ) : ('') } 
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </main>
        </>
    );
}